import { z } from 'zod';
import { StepFunctionTaskContextSchema } from '../request.js';
import { GatherTemplateTokensInputSchema, GatherTemplateTokensOutputSchema, } from './gatherTemplateTokens.js';
export const RetrieveTokenValuesInputSchema = GatherTemplateTokensInputSchema.merge(GatherTemplateTokensOutputSchema);
export const RetrieveTokenValuesOutputSchema = z.object({
    retrieveTokenValuesResults: z.object({ tokenMap: z.record(z.string(), z.string()) }),
});
export const RetrieveTokenValuesRequestSchema = z.object({
    context: StepFunctionTaskContextSchema,
    input: RetrieveTokenValuesInputSchema,
});
export const RetrieveTokenValuesResponseSchema = RetrieveTokenValuesOutputSchema.shape.retrieveTokenValuesResults;
